import { lazy, Suspense } from 'react'
import { createBrowserRouter, Navigate, Outlet } from 'react-router-dom'
import { Spin } from 'antd'
import { AppShell } from '@/shared/components/AppShell'
import { RequireAuth, RedirectIfAuthed } from './guards'

const LoginPage = lazy(() => import('@/modules/login/LoginPage'))
const RoleSelectPage = lazy(() => import('@/modules/login/RoleSelectPage'))
const DashboardPage = lazy(() => import('@/modules/dashboard/DashboardPage'))
const CommandCenterPage = lazy(() => import('@/modules/sch/CommandCenterPage'))
const TacChienModule = lazy(() => import('@/modules/tac-chien'))
const KeHoachBayModule = lazy(() => import('@/modules/ke-hoach-bay'))
const DanDuongModule = lazy(() => import('@/modules/dan-duong'))
const VanTaiModule = lazy(() => import('@/modules/van-tai'))
const KhiTuongModule = lazy(() => import('@/modules/khi-tuong'))
const BaoDongModule = lazy(() => import('@/modules/bao-dong'))
const HauCanModule = lazy(() => import('@/modules/hau-can'))
const YTeModule = lazy(() => import('@/modules/y-te'))
const DaoTaoModule = lazy(() => import('@/modules/dao-tao'))
const WorkflowModule = lazy(() => import('@/modules/workflow'))
const GISModule = lazy(() => import('@/modules/gis'))
const NotifModule = lazy(() => import('@/modules/notif'))
const UserAdminModule = lazy(() => import('@/modules/user-admin'))
const DashboardCmdModule = lazy(() => import('@/modules/dashboard-cmd'))
const InnovationModule = lazy(() => import('@/modules/innovation'))
const ReportsModule = lazy(() => import('@/modules/reports'))
const DanhMucModule = lazy(() => import('@/modules/danh-muc'))
const AdminModule = lazy(() => import('@/modules/admin'))
const AIModule = lazy(() => import('@/modules/ai'))
const HelpModule = lazy(() => import('@/modules/help'))

function PageFallback() {
  return (
    <div className="flex items-center justify-center h-full w-full p-12">
      <Spin size="large" />
    </div>
  )
}

function ShellLayout() {
  return (
    <AppShell>
      <Suspense fallback={<PageFallback />}>
        <Outlet />
      </Suspense>
    </AppShell>
  )
}

function AuthLayout() {
  return (
    <Suspense fallback={<PageFallback />}>
      <Outlet />
    </Suspense>
  )
}

export const router = createBrowserRouter([
  {
    path: '/login',
    element: (
      <RedirectIfAuthed>
        <AuthLayout />
      </RedirectIfAuthed>
    ),
    children: [{ index: true, element: <LoginPage /> }],
  },
  {
    path: '/select-role',
    element: (
      <Suspense fallback={<PageFallback />}>
        <RoleSelectPage />
      </Suspense>
    ),
  },
  {
    path: '/',
    element: (
      <RequireAuth>
        <ShellLayout />
      </RequireAuth>
    ),
    children: [
      { index: true, element: <Navigate to="/dashboard" replace /> },
      { path: 'dashboard', element: <DashboardPage /> },
      { path: 'sch', element: <CommandCenterPage /> },
      { path: 'tac-chien/*', element: <TacChienModule /> },
      { path: 'ke-hoach-bay/*', element: <KeHoachBayModule /> },
      { path: 'dan-duong/*', element: <DanDuongModule /> },
      { path: 'van-tai/*', element: <VanTaiModule /> },
      { path: 'khi-tuong/*', element: <KhiTuongModule /> },
      { path: 'bao-dong/*', element: <BaoDongModule /> },
      { path: 'hau-can/*', element: <HauCanModule /> },
      { path: 'y-te/*', element: <YTeModule /> },
      { path: 'dao-tao/*', element: <DaoTaoModule /> },
      { path: 'workflow/*', element: <WorkflowModule /> },
      { path: 'gis/*', element: <GISModule /> },
      { path: 'notif/*', element: <NotifModule /> },
      { path: 'user-admin/*', element: <UserAdminModule /> },
      { path: 'dashboard-cmd/*', element: <DashboardCmdModule /> },
      { path: 'innovation/*', element: <InnovationModule /> },
      { path: 'bao-cao/*', element: <ReportsModule /> },
      { path: 'danh-muc/*', element: <DanhMucModule /> },
      { path: 'admin/*', element: <AdminModule /> },
      { path: 'ai/*', element: <AIModule /> },
      { path: 'help', element: <HelpModule /> },
    ],
  },
  {
    path: '*',
    element: <Navigate to="/dashboard" replace />,
  },
])
